import { createComponent } from '@carvana/merch-components';

const Pulser = createComponent('div', {
  className: 'animate-pulse rounded-md bg-background-disabled-subtle'
});

export const SkeletonTextSmall = createComponent(Pulser, {
  className: 'h-16'
});

export const SkeletonTextMedium = createComponent(Pulser, {
  className: 'h-20'
});
